// Core
import { useState } from 'react';
import { useMutation } from '@apollo/react-hooks';
import { useHistory } from 'react-router-dom';

import { loader } from 'graphql.macro';
import storage from '../../../utils/storage';
import { parseJwt } from '../../../utils/parseJwt';
import { path } from '../../../utils/routers/book';
import { Form, UseHcpSignIn } from '../types';
import { CheckPin, UseHcpCheckPin, UseHcpResendPinCode } from '../../../components/auth/types';
import { useMutationRequest } from '../../../hooks/feature/useMutationRequest';
import { client } from '../../../utils/init/client';

// Mutations
const mutationSignIn = loader('./gql/mutationSignIn.graphql');
const mutationHcpAuthCheckPin = loader('./gql/mutationHcpCheckPinCodeFromEmail.graphql');
const mutationResendPinCode = loader('./gql/mutationHcpSendPinCodeToEmail.graphql');

// First step auth
export const useHcpSignIn = (): UseHcpSignIn => {
  const [errorMessage, setErrorMessage] = useState('');

  const [_healthcareSignIn, { loading, data }] = useMutation(mutationSignIn, {
    fetchPolicy: 'no-cache',
  });

  const authorizedHcp = data && data.hcpLogin;

  const _signInFirstStepAuthHcp = (form: Form): void => {
    setErrorMessage('');
    _healthcareSignIn({
      variables: {
        hcpLoginData: form,
      },
    })
      .then((signInData) => signInData)
      .catch((err: any) => setErrorMessage(err?.graphQLErrors?.[0]?.message));
  };

  return {
    _signInFirstStepAuthHcp,
    firstStepAuthLoadingHcp: loading,
    errorMessageFirstStepAuthHcp: errorMessage,
    firstStepAuthAuthorizedHcp: authorizedHcp,
  };
};

// Second step auth
export const useHcpCheckPin = (): UseHcpCheckPin => {
  const [errorMessage, setErrorMessage] = useState('');

  const [_healthcareSignIn, { loading, data }] = useMutation(mutationHcpAuthCheckPin, {
    fetchPolicy: 'no-cache',
  });

  const authorizedHcp = data && data.hcpCheckPinCodeFromEmail;
  const token = authorizedHcp && authorizedHcp.access_token;
  const refresh_token = authorizedHcp && authorizedHcp.refresh_token;

  const _authHcpCheckPin = (form: CheckPin): void => {
    _healthcareSignIn({
      variables: {
        checkPinCodeData: form,
      },
    })
      .then((signInData: any) => signInData)
      .catch((error: any) => setErrorMessage(error?.graphQLErrors?.[0]?.message));
  };

  const { email, id, role, lang } = parseJwt(token);
  const history = useHistory();

  if (token) {
    const setUser = {
      email,
      id,
      role,
      token,
      refresh_token,
      lang,
    };
    storage.save('user', setUser);
    storage.save('lang', lang);
    // window.location.assign(path.dashboardList);
    history.push(path.dashboardList);
  }
  return {
    setErrorMessage,
    _authHcpCheckPin,
    authHcpCheckPinLoading: loading,
    authHcpCheckPinError: errorMessage,
  };
};

// Resend PIN
export const useHcpResendPinCode = (): UseHcpResendPinCode => {
  const [_send, { data, errorText, loading }] = useMutationRequest<{ hcpSendPinCodeToEmail: {} }>(
    mutationResendPinCode,
    {},
  );
  const _resendPinCode = (email: string): void => {
    _send({
      variables: {
        sendPinCodeData: {
          email,
        },
      },
    });
  };

  return {
    _resendPinCode,
    dataPinCode: data && data.hcpSendPinCodeToEmail,
    errorPinCode: errorText,
    loadingSensPin: loading,
  };
};
